import { Booklet } from '../../../types/generated.types'

export interface BookletFolder {
  title: string
  folderName: string
}

export const sanitizeFileSystemName = (name: string): string =>
  name
    // Replace characters: / \ : * ? " < > | with safe dash
    .replace(/[\\/:*?"<>|]/g, '-')
    .replace(/\s+/g, ' ')
    .trim()

const formatDate = (value?: string | null): string | null => {
  if (!value) return null
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null
  const [year, month, day] = date.toISOString().split('T')[0].split('-')
  return `${year}${month}${day}`
}

export const createBookletFolderName = (booklet: Booklet): string => {
  const validFrom = formatDate(booklet.validFrom as string | undefined)
  const validTo = formatDate(booklet.validTo as string | undefined)

  if (validFrom || validTo) {
    const range = `${validFrom ?? 'okänt'}–${validTo ?? 'okänt'}`
    return sanitizeFileSystemName(`${booklet.title} ${range}`)
  }

  return sanitizeFileSystemName(booklet.title)
}

export const buildBookletFolders = (booklets: Booklet[]): BookletFolder[] => {
  const usedNames = new Set<string>()

  return booklets.map((booklet, index) => {
    let folderName = createBookletFolderName(booklet)

    if (!folderName) {
      folderName = `Häfte-${index + 1}`
    }

    let uniqueName = folderName
    let counter = 2
    while (usedNames.has(uniqueName)) {
      uniqueName = `${folderName} (${counter})`
      counter += 1
    }

    usedNames.add(uniqueName)

    return {
      title: booklet.title,
      folderName: uniqueName
    }
  })
}

